module.exports = {"610118001":"甘亭街道","610118002":"余下街道","610118003":"玉蝉街道","610118004":"五竹街道","610118005":"大王街道","610118006":"秦渡街道","610118007":"草堂街道","610118008":"庞光街道","610118009":"祖庵街道","610118010":"渭丰街道","610118011":"涝店街道","610118012":"甘河街道","610118013":"蒋村街道","610118014":"石井街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610118.json
// module id = 2922
// module chunks = 0